import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { BidderService } from '../services/bidder.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private bidderService: BidderService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        // Check if this is an embedded iframe request
        const embedParam = route.queryParams['embed'];
        const isEmbedded = embedParam === 'true' || embedParam === '1';
        
        if (isEmbedded) {
            // Allow access without authentication for embedded mode
            const enterpriseGuid = route.queryParams['GTAEnterpriseGUID'];
            if (enterpriseGuid) {
                // Check if embedded user already exists
                const existingUser: any = this.authenticationService.currentUserValue;
                if (!existingUser || existingUser.userid !== 0) {
                    // Fetch enterprise details from API using the GUID
                    // Return an observable that waits for the API call to complete
                    return this.bidderService.GetSellerDetailsFromGuid(enterpriseGuid).pipe(
                        map((response: any) => {
                            if (response && response.EnterpriseId) {
                                const enterpriseId = response.EnterpriseId;
                                
                                // Store in session for API calls
                                sessionStorage.setItem('isEmbedded', 'true');
                                sessionStorage.setItem('embedEnterpriseId', enterpriseId.toString());
                                
                                // Create a minimal embedded user session
                                const embeddedUser: any = {
                                    userid: 0,
                                    roleid: 3,
                                    message: 'Success',
                                    username: 'EmbeddedUser',
                                    enterpriseid: enterpriseId,
                                    groupname: 'Enterprise',
                                    rolename: 'Seller',
                                    IsDLMS: 1
                                };
                                
                                sessionStorage.setItem('currentUser', JSON.stringify(embeddedUser));
                                (this.authenticationService as any).currentUserSubject.next(embeddedUser);
                            }
                            return true;
                        }),
                        catchError((error) => {
                            console.error('Error fetching seller details:', error);
                            return of(true); // Allow navigation even if API fails
                        })
                    );
                }
            }
            return true;
        }        
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }
}